import ImageButtons from './ImageButtons'
import SyncButtons from './SyncButtons'

export { ImageButtons, SyncButtons }



// WEBPACK FOOTER //
// ./src/features/popup/components/onboardingButtons/index.js